import styles from "./home.module.css"
import TEDxHero from "./TedxHero";
import TEDxShipOfTheseus from "./theme";
const  Homecompo= () => {
    return (
        <div>
            <TEDxShipOfTheseus></TEDxShipOfTheseus>
           {/* <TEDxHero></TEDxHero> */}
        </div>
    );
}
 
export default Homecompo;

